import styled from 'styled-components'

export default styled.div`
  align-self: center;
  width: 16px;
  height: 16px;

  .shadeimg {
    width: 16px;
    height: 16px;
    display: block;
  }

  &.white {
    background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56"><path d="M55 1v54H1V1H55M56 0H0v56h56V0L56 0z"/></svg>');
    background-size: 99%;
    background-position: top left;
    background-repeat: no-repeat;
  }
`



// WEBPACK FOOTER //
// ./src/styles/ColorSwatch.js